import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import { makeStyles } from "@material-ui/core/styles";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import ApiService from "src/services/ApiService";

const useStyles = makeStyles((theme) => ({}));

const DialogChangePassword = (props) => {
  const classes = useStyles();
  const { onClose, open, showSnackBar, toggleBackdrop } = props;
  const [errorValidateNewPassword, setErrorValidateNewPassword] = useState(
    false
  );
  const [errorNewPassword, setErrorNewPassword] = useState(false);
  const [oldPassword, setOldPassword] = useState(null);
  const [newPassword, setNewPassword] = useState(null);
  const [newPassword2, setNewPassword2] = useState(null);
  const [canUpdatePassword, setCanUpdatePassword] = useState(false);

  useEffect(() => {
    if (
      !(oldPassword && newPassword && newPassword2 && !errorValidateNewPassword && !errorNewPassword)
    ) {
      setCanUpdatePassword(true);
    } else {
      setCanUpdatePassword(false);
    }
  }, [
    oldPassword,
    newPassword,
    newPassword2,
    errorValidateNewPassword,
    errorNewPassword,
  ]);

  const handleClose = () => {
    setOldPassword(null);
    setNewPassword(null);
    setErrorValidateNewPassword(false);
    onClose();
  };

  const handleCancel = () => {
    handleClose();
  };

  const handleOk = async () => {
    const params = {
      oldPassword,
      newPassword,
    };

    setCanUpdatePassword(!canUpdatePassword);

    try {
      const data = await ApiService.post("/auth/update-password", params);
      if (data && data.success) {
        showSnackBar({ mess: "Đổi mật khẩu thành công!", type: "success" });
        handleClose();
      } else {
        showSnackBar({ mess: "Lỗi", type: "error" });
      }
    } catch (error) {
      let mess = '';
      if (Array.isArray(error.messages[0].message)) {
        mess = error.messages[0].message[0].messages[0].message;
      } else {
        if (typeof error.messages[0].message === 'string') {
          mess = error.messages[0].message;
        }
      }
      showSnackBar({
        mess,
        type: "error",
      });
    }

    setCanUpdatePassword(!canUpdatePassword);
  };

  const validateNewPassword2 = (validateNewPasswordValue2) => {
    const test = validateNewPasswordValue2 === newPassword;
    setErrorValidateNewPassword(test ? false : true);
  };

  const validateNewPassword = (newPasswordValue) => {
    const test = (newPasswordValue || "").length >= 8;
    setErrorNewPassword(test ? false : true);
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="dialog-change-password"
      open={open}
    >
      <DialogTitle id="dialog-change-password-title">Đổi mật khẩu</DialogTitle>
      <DialogContent dividers>
        <form autoComplete="off" noValidate>
          <TextField
            variant="filled"
            id="old-password"
            required
            label="Mật khẩu cũ"
            type="password"
            fullWidth
            size="small"
            onChange={(event) => setOldPassword(event.target.value)}
          />
          <TextField
            variant="filled"
            id="new-password"
            required
            label="Mật khẩu mới"
            type="password"
            fullWidth
            size="small"
            className="mt-4"
            onChange={(event) => setNewPassword(event.target.value)}
            onBlur={(event) => validateNewPassword(event.target.value)}
            error={newPassword && errorNewPassword}
            helperText="Độ dài tối thiểu 8 kí tự."
            // helperText={newPassword && errorNewPassword ? "Vui lòng nhập giống mật khẩu mới" : ""}
          />
          <TextField
            variant="filled"
            id="validate-new-password"
            required
            label="Nhập lại mật khẩu mới"
            type="password"
            fullWidth
            size="small"
            className="mt-4"
            onChange={(event) => setNewPassword2(event.target.value)}
            onBlur={(event) => validateNewPassword2(event.target.value)}
            error={newPassword2 && errorValidateNewPassword}
            helperText={
              newPassword2 && errorValidateNewPassword
                ? "Vui lòng nhập giống mật khẩu mới"
                : ""
            }
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary">
          Huỷ
        </Button>
        <Button onClick={handleOk} color="primary" disabled={canUpdatePassword}>
          Đổi
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogChangePassword;
